// extracted by mini-css-extract-plugin
export default {"hintText":"BulkActions_hintText__uRS-B"};